module.exports = __webpack_public_path__ + "static/img/bg_index_contact.55b70a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_index_contact.jpg
// module id = Ej0w
// module chunks = 1